import { AuthState } from '@okta/okta-auth-js';

import { MetricTest } from '../services/backend/MetricTest';

import { useBaseApiClient } from './useBaseApiClient';

export const useMetricTestClient: () => MetricTest<AuthState> = () => {
  return useBaseApiClient(MetricTest);
};
